import { AfterViewInit, Component } from '@angular/core';

@Component({
  selector: 'app-nouvelle-sequence-card',
  imports: [],
  template: ` <div class="border-grey-3 rounded-lg border border-dashed px-6 py-4" id="newSequenceItem">
    <div class="flex flex-col gap-1">
      <span class="paragraph-large-semibold text-grey-10">Nouvelle séquence</span>
      <span class="paragraph-medium-medium text-grey-8">En cours de création dans le panneau de droite.</span>
    </div>
  </div>`,
})
export class NouvelleSequenceCardComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    document.getElementById('newSequenceItem')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
